var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta-box-overlay"},[_c('div',{staticClass:"cta-box"},[_c('p',[_vm._v(_vm._s(_vm.$t('gallery_not_logged_in')))]),_c('PrimaryButton',{staticClass:"cta-btn",attrs:{"accent":true},nativeOn:{"click":function($event){return _vm.goToSignup.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('gallery_not_logged_button'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }